export enum ErrorMessage {
	Default = 'An error has occurred',
	Server = 'Server error',
	Authorization = 'Authorization error',
	Credentials = 'Credentials error',
	MissingStateParam = 'Missing state parameter'
}

export const ErrorMessageLabel = {
	[ErrorMessage.Default]: $localize`:@@error_message.default:${ErrorMessage.Default}`,
	[ErrorMessage.Server]: $localize`:@@error_message.server:${ErrorMessage.Server}`,
	[ErrorMessage.Authorization]: $localize`:@@error_message.authorization:${ErrorMessage.Authorization}`,
	[ErrorMessage.Credentials]: $localize`:@@error_message.credentials:${ErrorMessage.Credentials}`,
	[ErrorMessage.MissingStateParam]: $localize`:@@error_message.missing_state_param:${ErrorMessage.MissingStateParam}`,
}

export enum WorkflowErrorType {
	InvalidState = 'invalid_state',
	SessionAlreadyUsed = 'session_already_used',
	InvalidSessionToken = 'invalid_session_token',
	FetchPlatformDataFailed = 'fetch_platform_data_failed',
	TokenGenerationFailed = 'token_generation_failed',
	UserCannotAccessAdAccount = 'user_cannot_access_ad_account',
	Default = 'default'
}

export enum WorkflowErrorMessageLabel {
	InvalidState = 'There is an error during the login process information mismatched',
	SessionAlreadyUsed = 'Your session token has expired',
	InvalidSessionToken = 'Your session token is invalid',
	FetchPlatformDataFailed = 'Impossible to contact the platform',
	TokenGenerationFailed = 'An error occurred on your token generation',
	UserCannotAccessAdAccount = 'The authenticated user cannot access the selected ad account for refresh process',
	Default = 'An error has occurred during the Connect process'
}

export const WorkflowErrorTypeLabel = {
	[WorkflowErrorType.InvalidState]: $localize`:@@workflow_error_type.invalid_state:${WorkflowErrorMessageLabel.InvalidState}`,
	[WorkflowErrorType.SessionAlreadyUsed]: $localize`:@@workflow_error_type.session_already_used:${WorkflowErrorMessageLabel.SessionAlreadyUsed}`,
	[WorkflowErrorType.InvalidSessionToken]: $localize`:@@workflow_error_type.invalid_session_token:${WorkflowErrorMessageLabel.InvalidSessionToken}`,
	[WorkflowErrorType.FetchPlatformDataFailed]: $localize`:@@workflow_error_type.fetch_platform_data_failed:${WorkflowErrorMessageLabel.FetchPlatformDataFailed}`,
	[WorkflowErrorType.TokenGenerationFailed]: $localize`:@@workflow_error_type.token_generation_failed:${WorkflowErrorMessageLabel.TokenGenerationFailed}`,
	[WorkflowErrorType.UserCannotAccessAdAccount]: $localize`:@@workflow_error_type.user_cannot_access_ad_account:${WorkflowErrorMessageLabel.UserCannotAccessAdAccount}`,
	[WorkflowErrorType.Default]: $localize`:@@workflow_error_type.default:${WorkflowErrorMessageLabel.Default}`,
}

export const TeamTypeOptions = (Object.keys(WorkflowErrorTypeLabel) as WorkflowErrorType[])
	.map((key: WorkflowErrorType) => ({
		value: key,
		label: WorkflowErrorTypeLabel[key],
	}));
